export default __webpack_public_path__ + "static/media/es.14df9a1a.svg";